import REPORTES from "./l3af-reportes";

const APP = {
  LANG: "es",
  INDEX: {
    REDIRECT_LOGIN: false,
  },
  ID: "bejuco",
  NAME: "BEJUCO",
  TITLE: "Bejuco",
  DESCRIPTION: "Bejuco",
  FAVICON: "favicon.png",
  LOGIN: "/login/bejuco",
  PROYECTO_VAINILLA: true,
  LOGIN_CONFIG: {
    TITLE: "Bejuco",
    DESCRIPTION: "",
    SIGNUP_TITLE: "Crear una cuenta",
    ALERT: "",
    DESCRIPTION_2: "Registrarse como proveedor.",
  },
  VALIDATIONS: {
    USER_ACCOUNT: false,
  },
  NAVBAR: {
    SHOW_TITLE: true,
    LOGO: { width: "168", height: "109", src: "logo_l3af.png" },
  },
  LOGO: "logo_l3af.png",
  ICON: "icon_l3af.png",
  COLORS: {
    primary: "#FFFFFF",
    secondary: "#EB3434",
    accent: "#44525d",
    text: "#212121",
  },
  FOLDER_EMAIL_LANDLORD: "",
  FUNCION_MANIPULAR_CASO: "",
  FUNCION_INICIALIZAR_CASO: "",
  CHIPS_TAREAS: true,
  AYUDAS: {
    ACTIVO: false,
    TITLE: "",
    ITEMS: [],
  },
  // Columnas de las tablas de MyTasks
  WORKFLOWS: {
    ONLINE_APPLICATIONS: {
      PENDING_TASKS: [
        {
          text: "Caso",
          value: "serialByMonth",
          sortable: false,
          label(item) {
            return `<code>${item.caso.serialByMonth}</code>`;
          },
        },
        {
          text: "Tarea",
          value: "nombre",
          sortable: false,
          label(item) {
            return item.nombre;
          },
        },
        {
          text: "Responsable",
          value: "responsable",
          sortable: false,
          label(item) {
            return item.nombre_responsable;
          },
        },
        {
          text: "Fecha Vencimiento",
          value: "fecha_vencimiento",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      ATTACHMENTS: {
        get(type, option) {
          switch (type) {
            case "completar-caso":
              return [];
            default:
              return [];
          }
        },
      },
      POP_UP_COMMENTS_VALUES: [{ label: "Cerrado", val: "-4" }],
      POP_UP_COMMENTS_KEY: "tarea_retorno",
    },
  },
  DOCUMENTS_COMMENTS: ["Other"],
  REPORTES,
  FORMS: {},
};

export default {
  prod_bejuco: {
    PORT: 3502,
    WEB_HOST: "https://l3af-test.llego.co/",
    API_HOST: "https://test-api.llego.co/api/v1/",
    SOCKET_HOST: "https://l3af-test.llego.co/",
    FOLDER: "_crd_entidades",
    APP,
    SUBSTATES: {
      DEFAULT: "NO_RADICADO",
      NO_RADICADO: "NO_RADICADO",
      RADICADO: "RADICADO",
    },
    SUBSTATES_CONFIG: {
      NO_RADICADO: {
        id: "NO_RADICADO",
        name: "NO RADICADO",
        name_en: "NOT RADICATED",
        color: "orange",
      },
      RADICADO: {
        id: "RADICADO",
        name: "RADICADO",
        name_en: "RADICATED",
        color: "green",
      },
    },
  },
};
